const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'STRING',
    key: 'page_title',
    label: 'Page Title',
    default: 'Contact Us'
  },
  {
    type: 'BOOLEAN',
    key: 'map',
    label: 'Map',
    default: false
  },
  {
    type: 'STRING',
    key: 'hero_image',
    label: 'Hero Image',
    default: 'https://s3-us-west-1.amazonaws.com/www.ff.com/us/web3/MTUwNTc4ODEzNDoyNDYzN2VmYgo/img/contact-hero.jpg'
  }
];

export default {
  id: 'HeroImage',
  name: 'Hero Image',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1503956140000,
  updatedAt: 1503956140000,
  slots,
  templateSettings,
  defaultProps
};
